import { Box, Typography } from '@mui/material';
import { formatDealAmount } from 'helper/short-currency';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import zeplinColor from 'theme/Color';
import { Variant } from './type';

const Card = ({ variant = 'big', data }: { variant?: Variant; data: any }) => {
  return (
    <Link
      to={`https://${data.website}`}
      target='_blank'
      rel='noopener noreferrer'
      style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
    >
      {renderContent[variant](data)}
    </Link>
  );
};

const renderContent: Record<Variant, (data: any) => ReactNode> = {
  small: (data) => (
    <Box
      sx={{
        borderRadius: '14px',
        padding: '12px',
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: zeplinColor.Neutral3,
        ':hover': {
          backgroundColor: zeplinColor.Neutral4,
        },
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '12px',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '48px',
            height: '48px',
            borderRadius: '8px',
            backgroundColor: zeplinColor.Neutral1,
          }}
        >
          <img
            src={data?.logo}
            width='48px'
            height='48px'
            alt='industry'
            style={{ objectFit: 'contain', borderRadius: '8px' }}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = '/assets/zoominfo-fallback.svg';
            }}
          />
        </Box>
        <Typography sx={{ fontSize: '18px' }} color={zeplinColor.BasicBlack}>
          {data?.name}
        </Typography>
      </Box>
      <Box
        sx={{
          width: '24px',
          height: '24px',
          backgroundColor: zeplinColor.Neutral10,
          borderRadius: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onClick={() => {}}
      >
        <img src='/assets/arrow-next-white.svg' alt='arrow-next' />
      </Box>
    </Box>
  ),
  big: (data) => (
    <Box
      sx={{
        borderRadius: '14px',
        border: `1px solid ${zeplinColor.Neutral5}`,
        padding: '16px',
        display: 'flex',
        gap: '12px',
      }}
    >
      <Box
        sx={{
          width: '60px',
          height: '60px',
          borderRadius: '8px',
          backgroundColor: zeplinColor.Neutral3,
        }}
      >
        <img
          src={data.logo}
          width='60px'
          height='60px'
          alt='industry'
          style={{ objectFit: 'contain' }}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = '/assets/zoominfo-fallback.svg';
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
          {data.name}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <img src='/assets/zoominfo-fallback.svg' width='20px' height='20px' alt='industry' />
            <Typography variant='responsiveBody3'>{data.industries[0]}</Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <img src='/assets/dollar-circle.svg' width='20px' height='20px' alt='industry' />
            <Typography variant='responsiveBody3'>
              {formatDealAmount(data.revenue)} Revenue
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  ),
};

export default Card;
